export function GetOrders() {
  return <>Lista zleceń</>
}